var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-select',{attrs:{"placeholder":"请选择渠道(默认全部)","filterable":"","clearable":""},on:{"change":_vm.handleChange},model:{value:(_vm.channelId),callback:function ($$v) {_vm.channelId=$$v},expression:"channelId"}},_vm._l((_vm.channelOptions),function(item){return _c('el-option',{key:item.value,attrs:{"label":item.label,"value":item.value}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }